import React, { useState, useEffect, useContext } from "react";
import Chart from "react-apexcharts";
import { PatientSetContext } from "../../Contexts/patientSetContext";

const Histogram = (props) => {
  const { patientSetInfo } = useContext(PatientSetContext);  

  const [series, setSeries] = useState([
    {
      data: [],
    }
  ]);

  const [options, setOptions] = useState({
    chart: {
      id: "basic-bar"
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        fill: "#ff0000",
        dataLabels: {
          position: "top"
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -15,
      style: {
        fontSize: "11px",
        colors: ["#666"],
      },
    },
    yaxis: {
      title: {
        text: `${patientSetInfo.patient_name} Count`,
      },
    },
    xaxis: {
      title: {
        text: props.entity
      },
      categories: [0, 0, 0, 0, 0, 0],
      convertedCatToNumeric: false,
      labels: {
        show: true,
        rotate: 360,
        hideOverlappingLabels: true,
        showDuplicates: false,
        formatter: function (value) {
          return value;
        },
        style: {
          colors: ["#000"],
          fontSize: "9px",
          padding: "3px",
          cssClass: "apexcharts-xaxis-label",
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const range0 = w.globals.labels[dataPointIndex];
        const range1 = w.globals.labels[dataPointIndex + 1] ? w.globals.labels[dataPointIndex + 1] : "";
        const count = series[seriesIndex][dataPointIndex];
        const lastIndex = series[seriesIndex].length - 1;
    
        let rangeText = range0;
        if (dataPointIndex === lastIndex) {
          rangeText = `>${range0}`;
        } else if (range1) {
          rangeText = `${range0} - ${range1}`;
        }

        return (
          '<div class="arrow_box3">' +
          `<div> <span><b>${props.entity} Range</b>: ` +
          rangeText +
          "</span> </div>" +
          "<br/>" +
          `<span><b>${patientSetInfo.patient_name} count</b>: ` +
          count +
          "</span>" +
          "</div>"
        );
      },
    },
    title: {
      text: "",
    },
  });


  useEffect(() => {
    setSeries(props.histoSeries);
    console.log('Histo Series => ', props.histoSeries);
    setOptions(prevState => ({
      ...prevState,
      xaxis: props.histoOptions.xaxis
    }));

  }, [props.histoSeries, props.histoOptions])

  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart
            options={options}
            series={series}
            type="bar"
            width={props.histoSeries[0]?.data.length > 30 ? "1250px" : "1250px"}
            height="450px"
          />
        </div>
      </div>
    </div>
  );
};

export default Histogram;
